import Chart from 'chart.js'

const PALETTE = ['#00707f', '#f7b84b', '#f672a7', '#4ecdc4']

/**
 * Method to render a line chart into an in-memory canvas and trigger a PNG download of it.
 * Chart.js draws with the colors passed in configuration only, so it does not depend on the
 * page's stylesheets and is not affected by any DOM/CSS capture limitation the visible
 * Chartist graph may have.
 * @param {Array} labels - X axis labels, shared by every dataset.
 * @param {Array} datasets - Array of { data: Array<Number>, label: String }, one per line.
 * @param {String} filename - The name of the downloaded file, without extension.
 * @returns {Boolean} - True if the image was generated and downloaded, false if not.
 */
const downloadLineChartImage = (labels, datasets, filename = 'grafica') => {
  if (!labels || !datasets || !datasets.length) {
    console.log('downloadLineChartImage: invalid chart data')
    return false
  }

  try {
    const canvas = document.createElement('canvas')
    canvas.width = 900
    canvas.height = 450

    const chart = new Chart(canvas.getContext('2d'), {
      type: 'line',
      data: {
        labels,
        datasets: datasets.map((dataset, index) => ({
          label: dataset.label || `Serie ${index + 1}`,
          data: dataset.data,
          borderColor: PALETTE[index % PALETTE.length],
          backgroundColor: datasets.length === 1 ? 'rgba(0, 112, 127, 0.1)' : 'transparent',
          fill: datasets.length === 1,
          tension: 0,
        })),
      },
      options: {
        responsive: false,
        maintainAspectRatio: false,
        animation: { duration: 0 },
        legend: { display: true },
      },
    })

    const link = document.createElement('a')
    link.download = `${filename}.png`
    link.href = chart.toBase64Image()
    link.click()

    chart.destroy()

    return true
  } catch (error) {
    console.log(error)
    return false
  }
}

export {
  downloadLineChartImage
}
